export default "/images/c411f2ab68358786c83d9a1a5e6dd43b.avif";